import { useState } from "react";
import { useAdminAuth } from "./useAdminAuth";
import { useAdminLang } from "../hooks/useAdminLang";
import { Navigate } from "react-router-dom";
import s from "./AdminLogin.module.css";

export default function AdminLogin() {
  const { admin, login, resetPassword, error } = useAdminAuth();
  const { t, lang, setLang } = useAdminLang();
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [busy, setBusy] = useState(false);
  const tr = t.login;
  const errorMessage = error === "not-authorized"
    ? (lang === "tr" ? "Bu hesabın yönetici erişimi yok." : "This account does not have administrator access.")
    : error === "admin-profile-unavailable"
      ? (lang === "tr" ? "Yönetici profili doğrulanamadı." : "The administrator profile could not be verified.")
      : tr.wrongCredentials;

  if (admin) return <Navigate to="/admin" replace />;

  async function handleSubmit(e) {
    e.preventDefault();
    setBusy(true);
    await login(email, pass);
    setBusy(false);
  }

  return (
    <div className={s.page}>
      <form className={s.card} onSubmit={handleSubmit}>
        <div className={s.brand}>
          <span className={s.logo}>B</span>
          <h1>{tr.title}</h1>
        </div>

        {error && <p className={s.error}>{errorMessage}</p>}

        <label className={s.label}>
          {tr.email}
          <input
            className={s.input}
            type="email"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>

        <label className={s.label}>
          {tr.password}
          <input
            className={s.input}
            type="password"
            required
            value={pass}
            onChange={(e) => setPass(e.target.value)}
          />
        </label>

        <button className={s.btn} type="submit" disabled={busy}>
          {busy ? tr.signingIn : tr.signIn}
        </button>

        <button
          type="button"
          onClick={async () => {
            if (!email.trim()) return;
            const sent = await resetPassword(email);
            if (sent) {
              window.alert(lang === "tr"
                ? "Şifre sıfırlama bağlantısı gönderildi."
                : "Password reset link sent.");
            }
          }}
          style={{
            background: "none",
            border: "none",
            cursor: email.trim() ? "pointer" : "not-allowed",
            color: "#666",
            marginTop: 12,
            width: "100%",
          }}
          disabled={!email.trim()}
        >
          {lang === "tr" ? "Şifremi unuttum" : "Forgot password?"}
        </button>

        {/* Language toggle on login screen */}
        <button
          type="button"
          onClick={() => setLang(lang === "en" ? "tr" : "en")}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: 12,
            color: "#888",
            marginTop: 12,
            width: "100%",
          }}
        >
          {lang === "en" ? "🇹🇷 Türkçe" : "🇬🇧 English"}
        </button>
      </form>
    </div>
  );
}
